
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    class="eye__icon {$$props.class}"
    disabled={$$props.disabled}
    on:click
  >
    <path
      d="M12.0007 9.005C13.0615 9.005 14.079 9.42643 14.8291 10.1766C15.5792 10.9267 16.0007 11.9441 16.0007 13.005C16.0007 14.0659 15.5792 15.0833 14.8291 15.8334C14.079 16.5836 13.0615 17.005 12.0007 17.005C10.9398 17.005 9.92239 16.5836 9.17225 15.8334C8.4221 15.0833 8.00067 14.0659 8.00067 13.005C8.00067 11.9441 8.4221 10.9267 9.17225 10.1766C9.92239 9.42643 10.9398 9.005 12.0007 9.005ZM12.0007 10.505C11.3376 10.505 10.7017 10.7684 10.2329 11.2372C9.76407 11.7061 9.50067 12.342 9.50067 13.005C9.50067 13.668 9.76407 14.3039 10.2329 14.7728C10.7017 15.2416 11.3376 15.505 12.0007 15.505C12.6637 15.505 13.2996 15.2416 13.7684 14.7728C14.2373 14.3039 14.5007 13.668 14.5007 13.005C14.5007 12.342 14.2373 11.7061 13.7684 11.2372C13.2996 10.7684 12.6637 10.505 12.0007 10.505ZM12.0007 5.5C16.6137 5.5 20.5967 8.65 21.7017 13.064C21.7501 13.2569 21.7198 13.4612 21.6176 13.6319C21.5154 13.8025 21.3496 13.9256 21.1567 13.974C20.9637 14.0224 20.7595 13.9922 20.5888 13.89C20.4181 13.7878 20.2951 13.6219 20.2467 13.429C19.7837 11.5925 18.7208 9.96306 17.2267 8.79913C15.7326 7.6352 13.8926 7.00338 11.9986 7.00384C10.1046 7.0043 8.26499 7.63701 6.7714 8.80167C5.27782 9.96632 4.21578 11.5962 3.75367 13.433C3.72984 13.5286 3.68741 13.6186 3.6288 13.6978C3.5702 13.777 3.49656 13.8439 3.41211 13.8946C3.32765 13.9454 3.23403 13.979 3.13658 13.9935C3.03914 14.0081 2.93978 14.0033 2.84417 13.9795C2.74857 13.9557 2.6586 13.9132 2.5794 13.8546C2.50019 13.796 2.43331 13.7224 2.38256 13.6379C2.33181 13.5535 2.2982 13.4599 2.28363 13.3624C2.26907 13.265 2.27384 13.1656 2.29767 13.07C2.83999 10.9073 4.08933 8.98777 5.84728 7.61627C7.60523 6.24476 9.77101 5.49991 12.0007 5.5Z"
      fill="#053900"
    />
  </svg>


<style>
  .eye__icon.error path {
    fill: #ff2e00;
  }
  .eye__icon{
    pointer-events: none;
  }
  .eye__icon[disabled="on"] {
    filter: grayscale(1);
    opacity: 0.25;
  }
 
</style>
